// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true
		// paginationType: boostPFSConfig.custom.pagination_type == 'infinite_scroll' ? 'infinite' :
		// 	(boostPFSConfig.custom.pagination_type == 'load_more' ? 'load_more' : 'default'),
	},
	template: {
		loadMoreLoading: '<div class="boost-pfs-filter-load-more-loading"><div class="load-more__icon" style="width: 44px; height: 44px; opacity: 1;"></div></div>'
	},
	selector: {
		breadcrumb: '.breadcrumb-collection'
	}
};

// Declare Templates
var boostPFSTemplate = {
	'saleLabelHtml': '<div class="sale_banner thumbnail_banner">' + boostPFSConfig.label.sale + '</div>',
    'newLabelHtml': '<div class="new_banner thumbnail_banner">' + boostPFSConfig.label.new + '</div>',
    'preorderLabelHtml': '<div class="new_banner thumbnail_banner">' + boostPFSConfig.label.pre_order + '</div>',
    'quickViewBtnHtml': '<span data-fancybox-href="#product-{{itemId}}" class="quick_shop ss-icon" data-gallery="product-{{itemId}}-gallery">&#x002B;</span>',
    'newRowHtml': '<br class="clear product_clear" />',

    // Grid Template
    'productGridItemHtml': '<div class="{{itemColumnNumberClass}} {{itemCollectionGroupThumbClass}} thumbnail {{itemCollectionGroupSmallClass}}" itemprop="itemListElement" itemscope itemtype="http://schema.org/Product"">' +
                               '<div class="product-wrap">' +
                                  '{{itemFlairHtml}}' +
                                    '<div class="relative product_image swap-' + boostPFSConfig.custom.secondary_image + '">' +
                                        '<a href="{{itemUrl}}" itemprop="url">' +
                                            '{{itemImages}}' +
                                        '</a>' +
                                        '<div class="thumbnail-overlay">' +
                                            '<a href="{{itemUrl}}" itemprop="url" class="hidden-product-link">{{itemTitle}}</a>' +
                                            '<div class="info">' +
                                                '{{itemProductInfoHover}}' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="banner_holder">' +
                                          '{{itemSaleLabel}}' +
                                          '{{itemNewLabel}}' +
                                          '{{itemPreorderLabel}}' +
                                        '</div>' +
                                    '</div>' +
                                    '<a class="product-info__caption {{itemHiddenClass}}" href="{{itemUrl}}" itemprop="url">' +
                                        '{{itemProductInfo}}' +
                                    '</a>' +
                                '</div>' +
                                '{{itemColorSwatches}}' +
                            '</div>',

    // Pagination Template
    'previousHtml': '<span class="prev"><a href="{{itemUrl}}">« ' + boostPFSConfig.label.paginate_prev + '</a></span>',
    'nextHtml': '<span class="next"><a href="{{itemUrl}}">' + boostPFSConfig.label.paginate_next + ' »</a></span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '{{sortingItems}}',
};


(function () { // Add this
	BoostPFS.inject(this); // Add this

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data, index) {
		if(!data) data = this.data;
		if (!index) index = this.index + 1;

		/*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) {
            return e.id == Utils.getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    var onSaleClass = onSale ? 'sale' : '';    
    var availabilityProp = soldOut ? 'http://schema.org/SoldOut' : 'http://schema.org/InStock';

    // Add custom class
    var itemColumnNumberClass = '';
    var itemCollectionGroupThumbClass = buildItemCollectionGroupThumbClass(index, boostPFSConfig.custom.products_per_row);
    var itemCollectionGroupLargeClass = '';
    var itemCollectionGroupMediumClass = '';
    var itemCollectionGroupSmallClass = (index - 1) % 2 == 0 ? 'even' : 'odd';
    switch (boostPFSConfig.custom.products_per_row) {
        case 2:
            itemColumnNumberClass = 'eight columns';
            break;
        case 3:
            itemColumnNumberClass = 'one-third column';
            break;
        case 4:
            itemColumnNumberClass = 'four columns';
            break;
        case 5:
            itemColumnNumberClass = 'one-fifth column';
            break;
        case 6:
            itemColumnNumberClass = 'one-sixth column';
            break;
        default:
            itemColumnNumberClass = 'one-seventh column';
            break;
    }

    if (boostPFSConfig.custom.mobile_products_per_row == 1) {
        itemColumnNumberClass += ' medium-down--one-half small-down--one-whole';
    } else {
        itemColumnNumberClass += ' medium-down--one-half small-down--one-half';    
    }

    itemHtml = itemHtml.replace(/{{itemColumnNumberClass}}/g, itemColumnNumberClass);
    itemHtml = itemHtml.replace(/{{itemCollectionGroupThumbClass}}/g, itemCollectionGroupThumbClass);
    itemHtml = itemHtml.replace(/{{itemCollectionGroupLargeClass}}/g, itemCollectionGroupLargeClass);
    itemHtml = itemHtml.replace(/{{itemCollectionGroupMediumClass}}/g, itemCollectionGroupMediumClass);
    itemHtml = itemHtml.replace(/{{itemCollectionGroupSmallClass}}/g, itemCollectionGroupSmallClass);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add onSale label
    var itemSaleLabel = boostPFSConfig.custom.sale_banner_enabled && onSale ? boostPFSTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Add Label (New, Coming soon, Pre order)
    var newLabel = data.collections.filter(function (e) {
        return e.handle == 'new';
    });
    var preorderLabel = data.collections.filter(function (e) {
        return e.handle == 'pre-order';
    });
    var comingsoonLabel = data.collections.filter(function (e) {
        return e.handle == 'coming-soon';
    });
    if (data.collections) {
        var itemNewLabelHtml = typeof newLabel[0] != 'undefined' ? boostPFSTemplate.newLabelHtml : '';
        itemHtml = itemHtml.replace(/{{itemNewLabel}}/g, itemNewLabelHtml);

        var itemComingsoonLabelHtml = typeof comingsoonLabel[0] != 'undefined' ? boostPFSTemplate.comingsoonLabelHtml : '';
        itemHtml = itemHtml.replace(/{{itemComingsoonLabel}}/g, itemComingsoonLabelHtml);

        var itemPreorderLabelHtml = typeof preorderLabel[0] != 'undefined' ? boostPFSTemplate.preorderLabelHtml : '';
        itemHtml = itemHtml.replace(/{{itemPreorderLabel}}/g, itemPreorderLabelHtml);
    }

    var itemHiddenClass = boostPFSConfig.custom.thumbnail_hover_enabled ? 'hidden' : '';
    itemHtml = itemHtml.replace(/{{itemHiddenClass}}/g, itemHiddenClass);

    // Get image source
    var itemImageSrc = 'data-src="' + Utils.getFeaturedImage(images, '900x') + '" ';
    itemImageSrc += 'data-srcset=" ' + Utils.getFeaturedImage(images, '300x') + ' 300w,';
    itemImageSrc += Utils.getFeaturedImage(images, '400x') + ' 400w,';
    itemImageSrc += Utils.getFeaturedImage(images, '500x') + ' 500w,';
    itemImageSrc += Utils.getFeaturedImage(images, '600x') + ' 600w,';
    itemImageSrc += Utils.getFeaturedImage(images, '700x') + ' 700w,';
    itemImageSrc += Utils.getFeaturedImage(images, '800x') + ' 800w,';
    itemImageSrc += Utils.getFeaturedImage(images, '900x') + ' 900w"';
    // Get Thumbnail url
    var itemThumbUrl = Utils.getFeaturedImage(images, '100x');
    // Get Flip image url
    var itemFlipImageUrl = images.length > 1 ? Utils.optimizeImage(images[1]['src']) : Utils.getFeaturedImage(images, '900x');

    // Add Thumbnail
    var product_set_width = data.featured_image.width;
    var align_height_value = '';
    if (boostPFSConfig.custom.align_height) {
        if (images.length > 0) {
            var collection_height = boostPFSConfig.custom.collection_height;
            var product_aspect_ratio = images[0]['width'] / images[0]['height'];
            product_set_width = product_aspect_ratio * collection_height;
            if (images[0]['width'] >= images[0]['height']) {
                align_height_value = 'width: 100%; height: auto;';
            } else {
                align_height_value = 'width: 100%;';
            }
        }
    }
    var itemImagesHtml = '<div class="image__container" style="max-width: ' + product_set_width + 'px;">';
    itemImagesHtml +=   '<img src="' + itemThumbUrl + '"' +
                        ' alt="{{itemTitle}}" ' +
                        ' class="lazyload ' + boostPFSConfig.custom.image_loading_style + '"' +
                        ' style="' + align_height_value + ' max-width: ' + data.featured_image.width + 'px;"' +
                        ' data-sizes="auto" ' + itemImageSrc + '/>';
    itemImagesHtml += '</div>';
    // Add Flip Image
    if (boostPFSConfig.custom.secondary_image) {
        itemImagesHtml += '<div class="image__container" style="max-width:';
        if (images.length > 1) {
            itemImagesHtml += images[1]['width'] + 'px">';
        } else {
            itemImagesHtml += data.featured_image.width + 'px">';
        }
        itemImagesHtml += '<img src="' + itemFlipImageUrl + '" class="secondary lazyload" alt="{{itemTitle}}" />';
        itemImagesHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Build Quick shop button
    var imageAttr = '';
    for (var k in images) {
        imageAttr += images[k]['src']+'^'+ data.title +'^'+  images[k]['id'];
        if (k + 1 == images.length) {
            imageAttr += '~';
        }
    }
    imageAttr = imageAttr.replace(/"/g, '&#34;');

    // Build Product Info when hovering 
    var itemProductInfoHoverHtml = '';
    if (boostPFSConfig.custom.thumbnail_hover_enabled && boostPFSConfig.custom.quick_shop_enabled) {
        itemProductInfoHoverHtml += '{{itemProductInfo}}';
        // itemProductInfoHoverHtml += quickShopBtnHtml;
    } else {
        if (boostPFSConfig.custom.thumbnail_hover_enabled) {
            itemProductInfoHoverHtml += '{{itemProductInfo}}';
        } else if (boostPFSConfig.custom.quick_shop_enabled) {
            // itemProductInfoHoverHtml += quickShopBtnHtml;
        }
    }
    itemHtml = itemHtml.replace(/{{itemProductInfoHover}}/g, itemProductInfoHoverHtml);

    // Build Product Info (product-info.liquid)
    var itemProductInfoHtml = '<div class="product-details">';
    itemProductInfoHtml += '<span class="title" itemprop="name">{{itemTitle}}</span>';
    itemProductInfoHtml += '{{itemReview}}';
    itemProductInfoHtml += '{{itemVendor}}';
    itemProductInfoHtml += '{{itemPrice}}';
    itemProductInfoHtml += '</div>';
    itemHtml = itemHtml.replace(/{{itemProductInfo}}/g, itemProductInfoHtml);

    // Add Review badge
    var itemReviewHtml = '';
    if (boostPFSConfig.custom.enable_shopify_review_comments && boostPFSConfig.custom.enable_shopify_collection_badges) {
        itemReviewHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
    }
    itemHtml = itemHtml.replace(/{{itemReview}}/g, itemReviewHtml);

    // Add Vendor
    var itemVendorHtml = '';
    if (boostPFSConfig.custom.vendor_enable) {
        itemVendorHtml = '<span itemprop="brand" class="brand">' + data.vendor + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = '';
    if (typeof comingsoonLabel[0] !== 'undefined') {
        itemPriceHtml += '<span class="modal_price">' + boostPFSConfig.label.coming_soon + '</span>';
    } else {
        itemPriceHtml += '<span class="price ' + onSaleClass + '" itemprop="offers" itemscope itemtype="http://schema.org/Offer">';
        itemPriceHtml += '<meta itemprop="price" content="' + data.price_min + '" />';
        itemPriceHtml += '<meta itemprop="priceCurrency" content="' + boostPFSConfig.shop.currency + '" />';
        itemPriceHtml += '<meta itemprop="seller" content="' + boostPFSConfig.shop.name + '" />';
        itemPriceHtml += '<meta itemprop="availability" content="' + availabilityProp + '" />';
        itemPriceHtml += '<meta itemprop="itemCondition" content="New" />';
        if (!soldOut) {
            if (priceVaries && data.price_min > 0) {
                itemPriceHtml += '<small><em>' + boostPFSConfig.label.from_price + '</em></small> ';
            }
            if (data.price_min > 0) {
                itemPriceHtml += '<span class="money" >' + Utils.formatMoney(data.price_min) + '</span>';
            } else {
                itemPriceHtml += boostPFSConfig.label.free_price;
            }
        } else {
            itemPriceHtml += '<span class="sold_out">' + boostPFSConfig.label.sold_out + '</span>';
        }
        if (onSale) {
            itemPriceHtml += ' <span class="was_price"><span class="money">' + Utils.formatMoney(data.compare_at_price_max) + '</span></span>';
        }
        itemPriceHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Swatches
    var itemColorSwatchesHtml = '';
    if (boostPFSConfig.custom.collection_swatches) {
        for (var k in data.options) {
            var option = data['options'][k];
            var downcasedOption = option.toLowerCase();
            var colorTypes = ['color', 'colour', 'farve'];
            if (colorTypes.indexOf(downcasedOption) > -1) {
                var option_index = k;
                var values = [];
                itemColorSwatchesHtml += '<div class="collection_swatches">';
                for (var i in data.variants) {
                    var variant = data['variants'][i];
                    var value = variant['options'][option_index];
                    if (values.indexOf(value) == -1) {
                        var values = values.join(',');
                        values += ',' + value;
                        values = values.split(',');
                        var fileColorUrl = boostPFSConfig.general.asset_url.replace('boost-pfs.js', Utils.slugify(value) + '.png');
                        fileColorUrl = Utils.optimizeImage(fileColorUrl, '50x');
                        itemColorSwatchesHtml += '<a href="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '" class="swatch" data-swatch-name="meta-' + downcasedOption + '_' + (value.replace(/\s/g, '_')).toLowerCase() + '">';
                        itemColorSwatchesHtml += '<span ';
                        if (boostPFSConfig.custom.products_per_row == 2) {
                            itemColorSwatchesHtml += 'data-image="' + Utils.optimizeImage(variant.image, '600x') + '" ';
                        } else if (boostPFSConfig.custom.products_per_row == 2) {
                            itemColorSwatchesHtml += 'data-image="' + Utils.optimizeImage(variant.image, '500x') + '" ';
                        } else {
                            itemColorSwatchesHtml += 'data-image="' + Utils.optimizeImage(variant.image, '400x') + '" ';
                        }
                        itemColorSwatchesHtml += 'style="background-image: url(' + fileColorUrl + '); background-color: ' + Utils.slugify(value.split(' ').pop()) + ';">';
                        itemColorSwatchesHtml += '</span>';
                        itemColorSwatchesHtml += '</a>';
                    }
                }
                itemColorSwatchesHtml += '</div>';
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, itemColorSwatchesHtml);

    // Flair
    itemHtml = itemHtml.replace(/{{itemFlairHtml}}/g, '<div data-flair-product-badge data-product-id="' + data.id.toString() + '"></div>');

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    return itemHtml;
	};

	// Build advanced class
  function buildItemCollectionGroupThumbClass(index, productsPerRow) {
    var temp = index < productsPerRow ? index : index % productsPerRow;
    if (temp == 0) {
        return 'omega';
    } else if (temp == 1) {
        return 'alpha';
    }
    return '';
  }

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		// Get page info
		if (!totalProduct) totalProduct = this.totalProduct;
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}
		return '';
	};

	ProductPaginationLoadMore.prototype.compileTotalTemplate = function() {
		/**
		 * If enable the Load previous feature and the evnet type is page:
		 * => Get the next loading page is from session storage OR get the next loading page from query param
		 */
		if (Utils.isLoadPreviousPagePaginationType() && this.parent.eventType == 'page') {
			this.nextPage = parseInt(window.sessionStorage.getItem(this.settings.sessionStorageCurrentNextPage));
		} else {
			this.nextPage = Globals.queryParams.page;
		}
		// Set from index
		var from = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		if (jQ(Selector.products + ' > div').length) {
			from -= jQ(Selector.products + ' > div').length - Globals.queryParams.limit;
		}
		// Set to index
		var product_index = (this.nextPage - 1) * Globals.queryParams.limit + 1;
		var to = product_index + this.data.products.length - 1;

		return this.getTemplate('total')
			.replace(/{{progressLable}}/g, Labels.loadMoreTotal)
			.replace(/{{ from }}/g, from)
			.replace(/{{ to }}/g, to)
			.replace(/{{ total }}/g, this.totalProduct)
			.replace(/{{class.productLoadMore}}/g, Class.productLoadMore)
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					if (sortingArr.hasOwnProperty(k)) {
						sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
					}
				}

				return boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return '';
	};

	// Sorting render
	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());
		var $selectInput = jQ(Selector.topSorting);
		if ($selectInput.length) {
			$selectInput.val(Globals.queryParams.sort);
		}
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		//var _this = this;
		jQ(Selector.topSorting).off('change');
		jQ(Selector.topSorting).change(function (e) {
			// Append "sort" param to url
			// Used to Scroll to the previous position after returning from Product page
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.applyFilter('sort');
		})
	};

	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
			var colInfo = colData.collection;

			var breadcrumbHtml = '<span ><a href="' + boostPFSConfig.shop.url + '" title="' + boostPFSConfig.shop.name + '" class="breadcrumb_link"><span>' + boostPFSConfig.label.breadcrumb_home + '</span></a></span> ';
			breadcrumbHtml += '<span class="breadcrumb-divider">/</span> ' +
				'<span><a href="{{currentCollectionLink}}" title="{{currentCollectionTitle}}" class="breadcrumb_link"><span>{{currentCollectionTitle}}</span></a></span> ';
			// Build Tags
			var currentTagsHtml = '';
			if (Array.isArray(boostPFSConfig.general.current_tags)) {
				var current_tags = boostPFSConfig.general.current_tags;
				for (var k = 0; k < current_tags.length; k++) {
					var tag = current_tags[k];
					currentTagsHtml += '<span class="breadcrumb-divider">/</span>';
					currentTagsHtml += '<span><a href="/collections/{{currentCollectionLink}}/' + Utils.slugify(tag) + '" title="' + tag + '"><span>' + tag + '</span></a></span>';
				}
			}
			breadcrumbHtml += currentTagsHtml;
			// Build Collection Info
			breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollectionLink}}/g, '/collections/' + colInfo.handle).replace(/{{currentCollectionTitle}}/g, colInfo.title);
			// Top Pagination
			breadcrumbHtml += ' <span class="boost-pfs-filter-top-pagination"></span>';
			return breadcrumbHtml;
		}
		return '';
	};

	// Call Theme function to Build additional elements for Product list
	ProductList.prototype.afterRender = function (data) {
		// Build Quick view data
		if (!data) data = this.data;

        // Flair
        if (typeof FlairApp !== 'undefined' && FlairApp) { FlairApp.refreshProductBadges(); }

		if (boostPFSConfig.custom.quick_shop_enabled) {
			this.buildExtrasProductListByAjax(data, 'boost-pfs-quickview', function(results) {
				results.forEach(function(result) {
					var element = '';
					if (boostPFSConfig.custom.quick_shop_style == 'inline') {
						element = jQ('[data-boost-theme-quickview="'+ result.id +'"]');
						if (element.find('.js-quick-shop-link').length == 0) {
							element.append(result.quickview);
						}
					} else {
						element = jQ('[data-boost-theme-quickview="'+ result.id +'"] div.info');
						if (element.find('.js-quick-shop-link').length == 0) {
							element.append(result.quickview);
						}
					}
				});
				buildTheme();
			});
		}
	};

	// Build Additional elements
	Filter.prototype.afterRender = function (data) {
		if (!data) data = this.data;
		// Remove InstantClick
		jQ(Selector.filterTree).find('a').attr('data-no-instant', '');

		// Remove product wrapper
		if (jQ(Selector.products).children().hasClass('product-list')) {
			jQ(Selector.products).children().children().unwrap();
		}

		// Build top pagination
		var totalPage = Math.ceil(data.total_product / Globals.queryParams.limit);
		var topPaginationHtml = '<span class="breadcrumb-divider">/</span> ' + (boostPFSConfig.label.breadcrumb_page).replace(/{{ current_page }}/g, Globals.queryParams.page).replace(/{{ pages }}/g, totalPage);
		jQ('.boost-pfs-filter-top-pagination').html(topPaginationHtml);
		jQ(".load-more__icon").remove();

		buildTheme();
	};

	function buildTheme() {
		// Multi currency
        if (boostPFSConfig.custom.show_multiple_currencies && window.convertCurrencies && typeof convertCurrencies == 'function') {
            convertCurrencies();
        }
	}
  
    FilterApi.beforeCall = function() {        
      	if (Utils.isSearchPage() && !Globals.queryParams.event_type) {
        	Globals.queryParams.sort = 'created-descending';
        }        
    }

})(); // Add this at the end